import { Button } from '@/components/ui/button'
import { Home as HomeIcon, Search, Heart, Star, Settings } from 'lucide-react'

export default function Home() {
  return (
    <div className="container mx-auto p-8">
      <h1 className="text-4xl font-bold mb-4">Hello World</h1>
      <p className="text-lg mb-6">
        This is an example root page with example components:
      </p>

      <div className="flex flex-wrap gap-4 mb-8">
        <Button>Example Button</Button>
        <Button variant="secondary">Secondary</Button>
        <Button variant="destructive">Destructive</Button>
        <Button variant="outline">Outline</Button>
        <Button variant="ghost">Ghost</Button>
        <Button variant="link">Link</Button>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-semibold mb-4">Lucide Icons</h2>
        <div className="flex flex-wrap gap-6 items-center">
          <div className="flex flex-col items-center gap-2">
            <HomeIcon className="w-8 h-8 text-primary" />
            <span className="text-sm text-muted-foreground">Home</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Search className="w-8 h-8 text-primary" />
            <span className="text-sm text-muted-foreground">Search</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Heart className="w-8 h-8 text-primary" />
            <span className="text-sm text-muted-foreground">Heart</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Star className="w-8 h-8 text-primary" />
            <span className="text-sm text-muted-foreground">Star</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Settings className="w-8 h-8 text-primary" />
            <span className="text-sm text-muted-foreground">Settings</span>
          </div>
        </div>
      </div>
    </div>
  )
}
